var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGoogle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    viewBox: "0 0 256000 255998",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    fillRule: "evenodd",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#176bef",
    d: "M62939 115673H33068v8864h21186c-1047 12430-11389 17731-21150 17731-12489 0-23387-9826-23387-23599 0-13417 10389-23749 23414-23749 10050 0 15972 6406 15972 6406l6205-6427s-7965-8868-22494-8868C14314 86030 0 101645 0 118511c0 16526 13463 32642 33286 32642 17433-1 30194-11943 30194-29603 0-3726-541-5879-541-5879z",
    opacity: 1,
    "data-original": "#176bef"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff3e30",
    d: "M87531 117475c6028 0 11740 4873 11740 12725 0 7687-5688 12698-11767 12698-6680 0-11951-5349-11951-12758 0-7251 5204-12665 11978-12665zm-122-8221c-12257 0-21041 9582-21041 20759 0 11340 8521 21101 21185 21101 11465 0 20859-8763 20859-20858 0-13863-10927-21002-21003-21002z",
    opacity: 1,
    "data-original": "#ff3e30",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b529",
    d: "M133292 117475c6029 0 11741 4873 11741 12725 0 7687-5689 12698-11768 12698-6679 0-11949-5349-11949-12758 0-7251 5204-12665 11976-12665zm-121-8221c-12256 0-21041 9582-21041 20759 0 11340 8520 21101 21185 21101 11465 0 20858-8763 20858-20858 0-13863-10926-21002-21002-21002z",
    opacity: 1,
    "data-original": "#f7b529"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#176bef",
    d: "M178871 117481c5516 0 11180 4709 11180 12752 0 8176-5653 12682-11302 12682-5997 0-11578-4870-11578-12604 0-8036 5796-12830 11700-12830zm-815-8205c-11250 0-20094 9854-20094 20914 0 12597 10253 20952 19900 20952 5966 0 9138-2368 11481-5085v4126c0 7222-4386 11547-11004 11547-6393-1-9599-4754-10713-7452l-8045 3363c2854 6033 8599 12326 18825 12326 11186 0 19711-7046 19711-21822v-37611h-8774v3546c-2698-2908-6389-4804-11287-4804z",
    opacity: 1,
    "data-original": "#176bef"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff3e30",
    d: "M237502 117276c3824 0 6576 2032 7745 4470l-18742 7834c-808-6065 4938-12304 10997-12304zm-366-8051c-10613 0-19523 8444-19523 20903 0 13184 9932 21003 20542 21003 8856 0 14291-4845 17536-9186l-7237-4814c-1877 2914-5016 5761-10254 5761-5883 0-8589-3222-10266-6342l28066-11646-1457-3413c-2712-6683-9037-12265-17406-12265z",
    opacity: 1,
    "data-original": "#ff3e30",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#179c52",
    d: "M204233 149888h9219V88195h-9219z",
    opacity: 1,
    "data-original": "#179c52"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGoogle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/google.ee07517d.svg";
export { ForwardRef as ReactComponent };